const SinglePortfolio = {
  init() {},
};

export default SinglePortfolio;
